import { useCompleteFragment } from '@eluve/apollo-client';
import { graphql } from '@eluve/graphql.tada';

import { useAppointmentId } from './appointment.context';

const fragment = graphql(`
  fragment AppointmentStartDate on Appointments {
    __typename
    id
    startDate
  }
`);

export const useAppointmentStartDate = () => {
  const id = useAppointmentId();

  const data = useCompleteFragment({
    fragment,
    key: {
      id,
    },
  });

  return data.startDate;
};
